import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Specialty } from 'types/specialty';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface SpecialtyItemProps {
  option: Specialty;
  selected: Specialty | null;
  handleSelect(specialty: Specialty): void;
}

const SpecialtyItem: React.FC<SpecialtyItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default SpecialtyItem;
